import { get, handleError } from '@/lib/http-adapter';
import { Subscription, SubscriptionGroup } from '@/state/subscription-groups';

export const getSubscriptionGroups = async (params: {
  include_subscriptions: boolean;
  class_id?: string;
}) => {
  try {
    const response = await get<{
      subscription_groups: SubscriptionGroup[];
    }>('/public/subscription-groups', { params });

    return response?.subscription_groups;
  } catch (error) {
    handleError(error);
  }
};

export const getSubscriptionDetails = async ({ slug }: { slug: string }) => {
  try {
    const response = await get<{ subscription: Subscription }>(
      `/public/subscriptions/${slug}`
    );
    return response?.subscription ?? null;
  } catch (error) {
    handleError(error);
  }
};
